const baseCN = {
  L001: "Sign up",
  L002: "Mobile",
  L003: "Verification code",
  L004: "Password",
  L005: "I have read and accepted the <<User Agreement>>",
  L006: "Sign up now",
  L007: "Back to the login",
  L008: "Sign in",
  L009: "Dynamic login",
  L010: "Mobile or Email",
  L011: "Please slide right to fill in the puzzle",
  L012: "Sign in",
  L013: "Forget the password",
  L014: "Sign up",
  L015: "Verified successfully",
  L016: "Verification faile",
  L017: "Sign in",
  L018: "Sign up",

  D001: "Company Search",
  D002: "Global Enterprise Background Information",
  D003: "Search Director Details",
  D004:
    "Help you get the company details, find your partners, know your competitors, complete the final trade",
  D005: "Suppliers, Buyers",
  D006: "Enterprises",
  D007: "Products",
  D008: "Credit Reports",
  D009: "Million+",
  D010: "Million+",
  D011: "Million+",
  D012: "Find about",
  D013: "companies",
  D014: "Country/Region",
  D015: "Employees",
  D016: "Revenue",
  D017: "Industry",
  D018: "More Filters",
  D019: "Website",
  D020: "Social Media",
  D021: "Contacts",
  D022: "Exclude Chinese Companies",
  D023: "More",
  D024: "Recommendations",
  D025: "Recently Viewed",
  D026: "Company List",
  D027: "Relevant",
  D028: "Employees",
  D029: "Contact Num",
  D030: "Select all",
  D031: "Company Information",
  D032: "Company Details",
  D033: "Key Labels",
  D034: "Favorites",
  D035: "Share",
  D036: "Company Overview",
  D037: "Contacts",
  D038: "News",
  D039: "Social Media",
  D040: "Sorry no information",
  D041: "Sorry, no contact information",
  D042: "By Product Keywords or Company Name",
  D043: "Key words",
  D044: "Top",
  D045: "contacts",
  D046: "Contact List",
  D047: "Contact Information",
  D048: "Contact Details",
  D049: "Company",
  D050: "More filters",
  D051: "Less",
  D052: "Fellow Contacts",
  D053: "View details",
  D054: "Favorites",
  D055: "Added",
  D056: "Please type in contact name",
  D057: "My Favorites",
  D058: "My Contacts",
  D059: "My Companies",
  D060: "Export",
  D061: "Membership",
  D062: "Invite friends",
  D063: "Log out",
  D064: "Balance",
  D065: "Type",
  D066: "Standard	",
  D067: "Top up",
  D068: "Upgrade",
  D069: " expires at",
  D070: "Account settings",
  D071: "Usage",
  D072: "Company verification",
  D073: "Messages",
  D074: "Account Information",
  D075: "User ID",
  D076: "Telephone	",
  D077: "Email",
  D078: "Verified",
  D079: "Verify",
  D080: "Change password",
  D081: "Personal Information",
  D082: "Nickname",
  D083: "Gender",
  D084: "Male",
  D085: "Female",
  D086: "Real Name",
  D087: "Company",
  D088: "Industry",
  D089: "Occupation",
  D090: "Address",
  D091: "Business card",
  D092: "Save",
  D093: "Usage in plan",
  D094: "Limits",
  D095: "Used",
  D096: "Remain",
  D097: "Price",
  D098: "Purchased",
  D099: "Record",
  D100: "Name",
  D101: "Type",
  D102: "Time",
  D103: "Total	",
  D104: "Verify your company",
  D105: "Benefits after verified",
  D106: "More Exposure",
  D107: "Global B2B buyers could find your company in the enterprise library.",
  D108: "More Balance",
  D109:
    'Your "Contacts Search" balance will increase 20 times after we check the verification.',
  D110: "Advanced recommendations",
  D111: "We will provide more targeted company information based on yours.",
  D112: "Company Name/Company Email",
  D113: "Company website",
  D114: "Industry",
  D115: "Contact Details",
  D116: "Occupation",
  D117: "Key procurement",
  D118: "Key products",
  D119: "Product pictures",
  D120: "Business card	",
  D121: "Company video",
  D122: "Verify now",
  D123: "Next time",
  D124: "Please type in",
  D125: "You have ",
  DD125: " messages unread",
  D126: "Title",
  D127: "Time",
  D129: "No data",
  D130: "Plans & Pricing",
  D131: "Functions	",
  D132: "VIP",
  D133: "Search Results",
  D134: "Information Export",
  DD134: "(Company basics: address, telephone, business scope, website etc.)",
  D135: "Advanced filters",
  DD135: "(Country/Region, employees, revenue, industry etc.)",
  D136: "Company search",
  D137: "Contacts search",
  D138: "Company details",
  D139: "Contacts details",
  D140: "Exclusive customer service",
  D141: "Upgrade now",

  D142: "Please type in Mobile Or Email",
  D143: "Dynamic login",
  D144: "Please type in Mobile",
  D145: "Get code",
  D146: "Please type in Email",
  D147: "Email",
  D148: "Please type in Verification code",
  D149: "Less",
  D150: "Please enter the country and region",
  D151: "Please type in Industry",
  D152: "Y",
  D153: "N",
  D154: "Required",
  D155: "Social Media",
  D156: "Tags",

  D157: "Meet all demands of credit investigation",
  D158:
    "By providing comprehensive credit reports based on background information, credit history, latest operation situation, profitability, industry news, cash flow, repayment willingness and ability, Xieco is offering you a robust solution to know your partners and evaluate credit risks of enterprises under investigation.",
  D159: "Recognize risks effectively by professional analysts",
  D160:
    "Distinguishing from other platforms that are crawling data only, Xieco holds a professional credit analysts team which has an average 10-year experience to help you analyze and verify on a large scale. ",
  D161: "Get credit reports",
  D162: "Submit the credit report form",
  D163: "Principal information",
  D164: "Required",
  D165: "Company Name",
  D166: "Please enter the full name of company",
  D167: "Please enter the full address",
  D168: "Please enter the zip code",
  D169: "Contact",
  D170: "Please enter the contact name",
  D171: "Tel",
  D172: "Fax",
  D173: 'Please enter the fax number, type "0" instead if there\'s not.',
  D174: "Please enter the email address",
  D175: "Enterprise/Industry under investigation",
  D176: "Company/Industry Name",
  D177: "Please enter the full name of company",
  D178: "Company Address",
  D179: "Country/Region",
  D180: "Please enter the country or region",
  D181: "Province/State",
  D182: "Please enter the province or state",
  D183: "Please enter the contact number",
  D184: "Major investigation",
  D185: "Please enter the major investigation",
  D186: "Reports generation rate",
  D187: "Regular",
  D188: "Premium",
  D189: "Notes",
  D190: "Please tell us any other requirement if you have",
  D191: "Submit",
  D192: "Cancel",

  D193: "Please enter the company name",
  D194: "Please enter the contact name",
  D195: "Please enter the contact number",
  D196: "Please enter the fax number",
  D197: "Please enter the full name of company",
  D198: "Please enter the full address",
  D199: "Please enter the country or region",
  D200: "MAP",
  D201: "loading...",
  D202: "Contact Details",
  D203: "Company search",
  D204: "Director search",
  D205: "My favorites",
  D206: "No Tags",
  D207: "Export to email",
  D208: "Export to excel",
  D209: "Delete",
  D210: "Search company instantly",
  D211: "Become the VIP, enjoy more benefits",
  D212: "Permanent Free",
  D213: "Renewal",
  D214: " pages",
  D215: "Purchase alerts",
  D216: "Purchase alerts",
  D217: "Purchase time",
  D218: "Stay tuned",
  D219: "Out-of-limit cost",
  D220: "",
  D221: "Company Verification",
  D228: "Company Name",
  D229: "Company Email",
  D230: "Please Enter Company Email",
  D231: "Company Website",
  D232: "Please enter the company website",
  D234: "Industry",
  D235: "Please enter the industry",

  D236: "Occupation",
  D237: "Please enter the occupation",
  D238: "Pocurement Key Words",
  D239: "Please enter the key words and press the enter",
  D240: "Key Products",

  D241: "Product Photos",
  D242: "Click here to upload pictures",
  D243: "Click here to update pictures",

  D244: "Business Card",
  D245: "Click here to upload business cards",
  D246: "Click here to update business cards",

  D247: "Company Video",
  D248: "Click here to update company videos",
  D249: "Click here to upload company videos",

  D250: "Verify now ",
  D251: "You have verified the listed company",
  D252: "Update the verified company",

  D253: "Account Settings",

  D254: "Account",
  D255: "You haven't connected",
  D256: "Connected",
  D257: "Change password",
  D258: "Update business card",

  D259: "Invite your partners (upstream and downstream)",
  D260: "Benefits of invitation",

  D261: "Get more recommendations",
  D262: "System will provide more similar companies based on your invitations",

  D263: "Invite to have more limits",
  D264:
    "View Contacts limit will be increased by 10 times after verifying one company successfully.",

  D265: "Upload the upstream and downstream companies  ",
  D266: "Tel",
  D267: "Please enter tel",

  D268: "Invited partners",
  D269: "You have uploaded the listed company",
  D270: "Verify status",
  D271: "Verifying",
  D272: "Verified successfully",
  D273: "Verification failed",

  D274: "Share or invite your coworkers and friends",
  D275: "Benefits of sharing and invitations",
  D276: "View more",
  D277:
    "View enterprise business cards of companies you shared with or invited.",
  D278: "Share by email",
  D279: "Enter the email address",
  D280: "Invite now",
  D281: "One record added",

  D282: "Invite successfully",
  D283: "You have invited the listed users successfully",

  D286: 'Unknown',
  D287: '10M & Under',
  D288: '500M & Above',
  D289: 'Product/Industry Key Words',
  D290: 'Company name',
  D291: 'second(s) ago ',
  D292: 'minute(s) ',
  D293: 'minute(s) ago ',
  D294: 'hour(s) ',
  D295: 'hour(s) ago ',
  D296: 'day(s) ',
  D297: 'day(s) ago ',
  D298: ' ago',
  D299: 'Week(s) ago',
  D300: 'Month(s) ago',
  D301: 'Accepting the user agreements is required',
  D302: 'The mobile number is invalid',
  D303: 'Please enter your mobile number',
  D304: 'The password should be between 8 and 20 characters ',
  D305: 'The account has been used.',
  D306: 'Hi Visitor',
  D307: 'Please sign up/sign in to get more benefits',
  D308: 'Add',
  D309: 'times',
  D310: 'View company details',
  D311: 'View contact details',
  D312: 'Please enter verification code',
  D313: 'Sign up',
  D314: 'User',
  D315: 'The account has been used.',
  D316: 'Verified successfully',
  D317: 'Verification failed',
  D318: 'The mobile number is invalid',
  D319: 'Verification code is invalid',
  D320: 'Connect successfully',
  D321: 'Connection failed',
  D322: 'The mobile number has been registered or connected',
  D323: 'The email address has been used to connect',
  D324: "The system is busy, login failed",
  D325: "Connection failed, the verification code is invalid",
  D326: "Please fill in the verification code",
  D327: "The system is busy, please try again later",
  D328: "Verification code has been sent successfully",
  D329: "Account does not exist.",
  D330: "Slider verification failed",
  D331: "Required parameter type is missing",
  D332: "Verification code for sign up",
  D333: "Verification code for email connection",
  D334: "Sent successfully",
  D335: "There's no balance for searching company",
  D336: "No restriction on viewing pages after login",
  D337: "Favorites are available after login",
  D338: "Delete successfully",
  D339: "Delete failed",
  D340: "Are you sure to delete the record?",
  D341: "Registration failed! Verification code error.",
  D342: "Username or password does not exist.",
  D343: "Register type does not exist.",
  D344: "The account has been used.",
  D345: "The mobile number has been used.",
  D346: "Please upload the business card in jpg/jpeg/bmp/png.",
  D347: "The business card can not exceed 2MB",
  D348: "Connect",
  D349: "Top",
  D350: "Feedback",
  D351: "Description",
  D352: "Please write down your feedbacks, we will take care of them and contact you soon",
  D353: "Thank you for your support, your suggestions would be our motivations to improve. ",
  D354: "Search contact instantly",
  D355: "There's no balance for searching contract",
  D356: "Advanced filters are available after login",
  D357: "View contact details after login",
  D359: "View details after login",
  D360: "Add to favorites after login",
  D361: "Standard members could not export",
  D362: "Standard members could not export",
  D363: "Sorry, the webpage failed to load",
  D364: "View Contacts",
  D365: "Company Overview",
  D366: "The standard member could only view the first ten pages",
  D367: "The video format you upload is not supported",
  D368: "It can’t exceed 100M",
  D369: "We are grateful to your verification and will review it in 3-5 days, the result will be sent to you in messages",
  D370: "Please enter a multiple of 1",
  D371: "Purchase items",
  D372: "Purchase history",
  D373: "Submitted successfully",
  D374: "Please scan the barcode in Wechat",
  D375: "Choose the recharge amount",
  D376: "Choose the payment method",
  D377: "Confirm to recharge",
  D378: "Other amounts $",
  D379: "$58/month",
  D380: "$39.9*12=478.8/Year",
  D381: "Message details",
  D382: "Data is provided by Xieco",
  D383: "Vistor could not export",
  D384: "Share by WeChat",
  D385: "Please scan in the WeChat app to share",
  D386: "Paying by Alipay",
  D387: "Paying by PayPal",
  D388: "Paying by WeChat",
  D389: "Sent to the connected email",
  D390: "No connected email, export failed",
  D391: "Keep me logging in for a week",
  D392: "ALL",
  D393: "Default group",
  D394: "Edit group",
  D395: "Rename or delete group",
  D396: "Add new group",
  D397: "Confirm",
  D398: "Please enter new group name",
  D399: "Confirm the creation",
  D400: "Back",
  D401: "Change the current group",
  D402: "Change group",
  D403: "Please select a group to join",
  D404: "Join group",
  D405: "Notice",
  D406: "The group has data,are you sure to delete?",
  D407: "Are you sure to delete?",
  D408: "Competitors",
  D409: "Customers",
  D410: "Suppliers",
  D411: "Distributors",
  D412: "Contact Info",
  D413: "No.601,Building B,Guojin Plaza,Qianpu Road,Siming District,Xiamen City,Fujian Province,China",
  D414: "Fujian ICP Record No.14014576,Fujian Public Security Record No.35020302028523",
  D415: "Business Support",
  D416: "Settings",
  D417: "Month",
  D418: "Found over 10,000 companies，top 10,000 companies are displayed",
  D419: "Found over 10000 contacts，top 10,000 results are displayed",
  D420: "Add to company group",
  D421: "Add to contact group",
  D422: "This function only for VIP users, please recharge for VIP package",
  D423: "10 companies/month",
  D424: "5 contacts/month",
  D425: "200 companies/month",
  D426: "2400 companies/year",
  D427: "20 contacts/month",
  D428: "240 contacts/year",
  D429: "$696/year",
  D430: 'Contact without email does not count',
  D431: 'The VIP quota for this month has been used up, you can recharge your account balance ',
  D432: 'Notes:',
  D433: '$58/month',
  D434: '$696/year',
  D435: 'Free',
  D436: 'month',
  D437: 'year',
  D438: '$',
  D439: 'Please type in Invitation Code',
  D440: 'Activate Code',
  D441: 'Activate',
  D442: 'Million+',
  D443: '',
  D444: 'Hundred+',
  D445: 'Second',
  D446: 'Enterprises',
  D447: 'Country/Region',
  D448: 'Industries',
  D449: 'Get Report Now',
  D450: 'Find Customers Faster',
  D451: 'Leads generation powered by Artificial Intelligence.',
  D452: 'Wechat',
  D453: 'Amount',
  D454: 'Xieco',
  D455: 'Service Upgrade',
  D456: 'Customized for business people，find your target contacts quickly and accurately',
  D457: 'More',
  D458: 'Company and Contact Data of 216 Countries',
  D459: 'Make Contact Data Drive the Future of Business',
  D460: 'Social Graph',
  D461: 'Introduction',
  D462: 'Feedback',
  D463: 'Directory',
  D464: 'Privacy',
  D465: 'ABOUT XIECO',
  D466: 'CONTACT US',
  D467: 'WECHAT',
  D468: 'Links',
  D469: '',
  D470: ' Month',
  D471: ' Months',
  D472: '',
  D473: '',
  D474: 'My fav',
  D475: 'Service',
  D476: '',
  D477: '',
  D478: 'Please enter product keywords or company name to search social graph',
  D479: ' ',
  D480: ',',
  D481: 'Xieco new version 2.2 has been released!',
  D482: '亲爱的小伙伴们，Xieco全新PC端2.2版本发布啦~',
  D483: 'The new version mainly contains the followings:',
  D484: '1. Home page optimized;',
  D485: '2. DD points function: you can earn DD points through tasks and use DD points to exchange benefits;',
  D486: '3. Optimized VIP package,multiple choices, applicable to various scenarios;',
  D487: 'Find out more by using our new version now!',
  D488: 'Tips: This update is for PC only, please use PC to experience our new functions',
  D489: 'I know',
  D490: 'Export Data',
  D491: 'Note: You can export company list data here . If you want to export favorite company data ,please go to "My Favorites" page.',
  D492: 'Note: You can export contact list data here . If you want to export favorite contact data ,please go to "My Favorites" page.',
  D493: 'Export Favorites',
  D494: 'Export List Data',



  D512: "Social Login:",
  D513: "Social Signup:"
};
export default baseCN;



// WEBPACK FOOTER //
// ./src/lan/en/en_base.js